import type { IconSvgObject } from './types';

const LinerIcon: IconSvgObject = [
  ["path", { d: "M3 20L21 4", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default LinerIcon;
